module.exports = __webpack_public_path__ + "img/0-109.6e37e998.jpg";